
/*@jsxRuntime automatic @jsxImportSource react*/
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p"
  }, props.components);
  return <><_components.h1>{"About"}</_components.h1>{"\n"}<_components.p>{"Check Run Reporter is the brainchild of Ian Remmel, caused by his frustration with\nthe lack of reporting tools in many popular CI systems and the realization that\nGitHub supplies many underused presentational capabilities."}</_components.p>{"\n"}<_components.p>{"Ian Remmel has been formally working in software for over a decade and,\ninformally, nearly another decade before that."}</_components.p>{"\n"}<_components.p>{"In his time at Cisco and Urbandoor, he became extremely familiar with legacy CI\nsystems like TeamCity and Jenkins and if you buy him a beer, he'll happily go\ninto exhaustive detail about their pros and cons (to be honest, it probably\nwon’t take a beer). For a long time, Circle CI was his go-to CI of choice, but\nhe now mostly sticks to GitHub Actions or Buildkite."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "_fixed.about.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    